import { dateFormat } from '../utils/formatter'
import useDateRangeCol from '../hooks/useDateRangeCol'

// Dates Tab
export const employeeAbsencePlanDatesCols = [
  {
    accessorKey: 'MASTR_ENTRY',
    header: 'Master Entry Date',
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'MSTR_ELIG_END',
    header: 'Master Eligibility End',
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'MSTR_END',
    header: 'Master End Date',
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'MSTR_OVERRIDE',
    header: 'Master Override',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'SRV_BEGIN_DT',
    header: 'Service Begin Date',
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'ACCR_BEGIN_DT',
    header: 'Accrual Begin Date',
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'ACCR_START_DT',
    header: 'Accrual Start Date',
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'ALLOT_BEGIN_DT',
    header: 'Allotment Begin Date',
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'ALLOT_POINT',
    header: 'Allotment Point',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'ELIG_BEGIN_DT',
    header: 'Eligibility Begin Date',
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'RESET_POINT',
    header: 'Reset Point',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'LST_PER_DT_HRS',
    header: 'Last Period Date Hours',
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'TRANSFER_FLAG',
    header: 'Transfer Flag',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'ACCR_LAST_DT',
    header: 'Accrual Last Date',
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'ALLOT_LAST_DT',
    header: 'Allotment Last Date',
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'ELIG_LAST_DT',
    header: 'Eligibility Last Date',
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'RESET_LAST_DT',
    header: 'Reset Last Date',
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'LST_PER_DT_ERN',
    header: 'Last Period Date Earnings',
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  }
]

// Balances Tab
export const employeeAbsencePlanBalancesCols = [
  {
    accessorKey: 'AVAIL_HRS_BAL',
    header: 'Available Hours Balance',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'ACCR_HRS_BAL',
    header: 'Accrued Hours Balance',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'ALLOT_HRS_BAL',
    header: 'Allotment Hours Balance',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'RESRV_HRS_BAL',
    header: 'Reserved Hours Balance',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'AVAIL_ERN_BAL',
    header: 'Available Earnings Balance',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'ACCR_ERN_BAL',
    header: 'Accrued Earnings Balance',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'ALLOT_ERN_BAL',
    header: 'Allotment Earnings Balance',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'RESRV_ERN_BAL',
    header: 'Reserved Earnings Balance',
    enableSorting: false,
    enableColumnFilter: false
  }
]

// Carryover Tab
export const employeeAbsencePlanCarryoverCols = [
  {
    accessorKey: 'CARRYOVER_END',
    header: 'Carryover End',
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'CARRY_HRS_BAL',
    header: 'Carryover Hours Balance',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'CARRY_ERN_BAL',
    header: 'Carryover Earnings Balance',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'OV_CARRY_HRS_A',
    header: 'Override Carryover Hours A',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'OV_CARRY_ERN_A',
    header: 'Override Carryover Earnings A',
    enableSorting: false,
    enableColumnFilter: false
  }
]

// GL Accounts Tab
export const employeeAbsencePlanGLAccountsCols = [
  {
    accessorKey: 'HRS_ACCR_CO',
    header: 'Hours Accrual Company',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'HRS_ACCR_UNIT',
    header: 'Hours Accrual Unit',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'HRS_ACCR_ACCT',
    header: 'Hours Accrual Account',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'HRS_ACCR_SUB',
    header: 'Hours Accrual Sub',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'HRS_EXP_CO',
    header: 'Hours Expense Company',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'HRS_EXP_UNIT',
    header: 'Hours Expense Unit',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'HRS_EXP_ACCT',
    header: 'Hours Expense Account',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'HRS_ACTIVITY',
    header: 'Hours Activity',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'HRS_ACCT_CAT',
    header: 'Hours Account Category',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'ERN_ACCR_CO',
    header: 'Earnings Accrual Company',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'ERN_ACCR_UNIT',
    header: 'Earnings Accrual Unit',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'ERN_ACCR_ACCT',
    header: 'Earnings Accrual Account',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'ERN_ACCR_SUB',
    header: 'Earnings Accrual Sub',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'ERN_EXP_CO',
    header: 'Earnings Expense Company',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'ERN_EXP_UNIT',
    header: 'Earnings Expense Unit',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'ERN_EXP_ACCT',
    header: 'Earnings Expense Account',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'ERN_ACTIVITY',
    header: 'Earnings Activity',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'ERN_ACCT_CAT',
    header: 'Earnings Account Category',
    enableSorting: false,
    enableColumnFilter: false
  }
]

// Override Tables Tab
export const employeeAbsencePlanOverrideTablesCols = [
  {
    accessorKey: 'OV_ACCR_HRS',
    header: 'Override Accrual Hours',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'OV_ALLOT_HRS',
    header: 'Override Allotment Hours',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'OV_BAL_HRS',
    header: 'Override Balance Hours',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'OV_ACRLIM_HRS',
    header: 'Override Accrual Limit Hours',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'OV_CARRY_HRS_T',
    header: 'Override Carryover Hours T',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'OV_HRS_LIA',
    header: 'Override Hours Liability',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'OV_ACCR_ERN',
    header: 'Override Accrual Earnings',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'OV_ALLOT_ERN',
    header: 'Override Allotment Earnings',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'OV_BAL_ERN',
    header: 'Override Balance Earnings',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'OV_ACRLIM_ERN',
    header: 'Override Accrual Limit Earnings',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'OV_CARRY_ERN_T',
    header: 'Override Carryover Earnings T',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'OV_ERN_LIA',
    header: 'Override Earnings Liability',
    enableSorting: false,
    enableColumnFilter: false
  }
]

// Payroll Tab
export const employeeAbsencePlanPayrollCols = [
  {
    accessorKey: 'OV_HRS_NEG_LMT',
    header: 'Override Hours Negative Limit',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'OV_HRS_LINK_TB',
    header: 'Override Hours Link TB',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'OV_HRS_PRO_ORD',
    header: 'Override Hours Processing Order',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'OV_HRS_NEG_BAL',
    header: 'Override Hours Negative Balance',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'OV_HRS_NEG_WEB',
    header: 'Override Hours Negative Web',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'OV_HRS_UNPD_CD',
    header: 'Override Hours Unpaid Code',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'OV_ERN_NEG_LMT',
    header: 'Override Earnings Negative Limit',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'OV_ERN_LINK_TB',
    header: 'Override Earnings Link TB',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'OV_ERN_PRO_ORD',
    header: 'Override Earnings Processing Order',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'OV_ERN_NEG_BAL',
    header: 'Override Earnings Negative Balance',
    enableSorting: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'OV_ERN_NEG_WEB',
    header: 'Override Earnings Negative Web',
    enableSorting: false,
    enableColumnFilter: false
  }
]

// Transactions Tab
export const useEmployeeAbsenceTransactionCols = () => {
  const dateCol = useDateRangeCol('DATE', 'Date')
  
  return [
    dateCol,
    {
      accessorKey: 'STATUS',
      header: 'Status',
      enableSorting: false,
      enableColumnFilter: true
    },
    {
      accessorKey: 'SEQ_NBR',
      header: 'SEQ',
      enableSorting: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'TRAN_TYPE',
      header: 'Transaction Type',
      enableSorting: false,
      enableColumnFilter: true
    },
    {
      accessorKey: 'AMOUNT',
      header: 'Amount',
      enableSorting: true,
      enableColumnFilter: false,
      Cell: ({ cell }) => {
        const value = cell.getValue();
        if (value === null || value === undefined) return '';
        const numVal = parseFloat(value);
        return !isNaN(numVal) ? numVal.toFixed(2) : value;
      }
    },
    {
      accessorKey: 'TA_TYPE',
      header: 'Type',
      enableSorting: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'TA_LOS_CALC',
      header: 'Cycle or HRS',
      enableSorting: false,
      enableColumnFilter: false
    }
  ]
}
